module.exports = __webpack_public_path__ + "img/background_Image.185a2bcc.png";